import React from "react";

import { ReactComponent as ExpertIcon } from "triangular/static/images/experts.svg";

import css from "./AddExpertIcon.module.scss";

export const AddExpertIcon: React.FC = () => <ExpertIcon className={css.expertOwnerIcon} />;
